export const getBuyer = ({ buyerReducer: { buyer } }) => buyer;
